export const SafeTxError = {
  FeeHasChanged: 'FeeHasChanged',
  UnspecifiedError: 'UnspecifiedError',
  CanceledByUser: 'CanceledByUser',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SafeTxError = (typeof SafeTxError)[keyof typeof SafeTxError];
export type SafeTxResponse = { isSuccessful: true } | { isSuccessful: false; error: SafeTxError };

export const SAFE_TX_SUCCESS: SafeTxResponse = { isSuccessful: true };
export const safeTxError = (error: SafeTxError): SafeTxResponse => ({ isSuccessful: false, error });
